<template>
  <div>
    <router-view class="default-font" :style="{ '--brand-color': app.brandInfo.color || '#503df6' }"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['app']),
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

/** 默认layout下字体 */
.default-font {
  font-family: Open Sans regular !important;
}
</style>
